import React, { useState } from 'react';
import { TOKEN, LINKS } from '../data/mock';
import { ExternalLink, Copy, Check } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

export default function Yours() {
  const [copied, setCopied] = useState(false);
  const { toast } = useToast();

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(TOKEN.contract);
      setCopied(true);
      toast({ title: 'Contract copied', description: 'Verify character by character before you swap.' });
      setTimeout(() => setCopied(false), 2000);
    } catch (e) { /* clipboard denied */ }
  };

  return (
    <section id="l9" className="chapter" style={{ flexDirection: 'column', justifyContent: 'center' }}>
      <div style={{ maxWidth: 1000, width: '100%', margin: '0 auto', textAlign: 'center' }}>
        <div className="chapter-eyebrow font-sans" style={{ margin: '0 auto 30px', justifyContent: 'center' }}>
          <span style={{ height: 1, width: 60, background: 'linear-gradient(to left, #f3c04a, transparent)' }} />
          LIFE IX · YOURS
          <span style={{ height: 1, width: 60, background: 'linear-gradient(to right, #f3c04a, transparent)' }} />
        </div>
        <p className="big-prose" style={{ textAlign: 'center', margin: '0 auto 30px' }}>
          Doge ran. Cate leapt.<br />
          <em><i>FISHE swims — and it only swims up.</i></em>
        </p>

        <div style={{ marginTop: 50 }}>
          <div style={{ color: '#8a8672', letterSpacing: '0.32em', fontSize: 11, marginBottom: 14 }} className="font-sans">
            TOKEN CONTRACT ADDRESS · SOLANA
          </div>
          <div className="contract-box">
            <span className="contract-address">{TOKEN.contract}</span>
            <button onClick={copy} className="copy-btn font-sans" style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
              {copied ? <Check size={12} /> : <Copy size={12} />} {copied ? 'COPIED' : 'COPY CONTRACT'}
            </button>
          </div>
          <div style={{ marginTop: 14, color: '#8a8672', fontSize: 12, letterSpacing: '0.08em' }} className="font-sans">
            check it on-chain before you swap → <a href={LINKS.solscan} target="_blank" rel="noreferrer" style={{ color: '#f3c04a', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 4 }}>SOLSCAN <ExternalLink size={11} /></a>
          </div>
        </div>

        <div className="buy-row">
          <a className="pill primary" href={LINKS.pumpfun} target="_blank" rel="noreferrer">BUY ON PUMP.FUN</a>
          <a className="pill" href={LINKS.fomo} target="_blank" rel="noreferrer">BUY ON FOMO</a>
          <a className="pill" href={LINKS.moonshot} target="_blank" rel="noreferrer">BUY ON MOONSHOT</a>
        </div>

        <div className="footer-links font-sans">
          <a href={LINKS.twitter} target="_blank" rel="noreferrer">X / TWITTER</a>
          <a href={LINKS.telegram} target="_blank" rel="noreferrer">TELEGRAM</a>
          <a href={LINKS.dexscreener} target="_blank" rel="noreferrer">DEXSCREENER</a>
          <a href={LINKS.dextools} target="_blank" rel="noreferrer">DEXTOOLS</a>
        </div>
      </div>
    </section>
  );
}
